import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import {
  START_GET_SEARCH_REPEAT_ORDER,
  RESET_REPEAT_ORDER_STATE,
  START_GET_REPEAT_ORDER_LIST,
} from "Actions/RepeatOrderAction";
import {
  START_REPEATORDER_TO_ORDERPAD,
  START_CREATE_ORDER_PAD,
  RESET_ORDER_PAD_STATE,
  START_CREATE_TODAY_ORDER_PAD,
} from "Actions/OrderPadAction";
import * as yup from "yup";
import { useFormik } from "formik";
import { useXssGuard } from "Hooks/useXssGuard";
import moment from "moment";
import { useNotification } from "Hooks/NotificationManager";
import { useNavigate } from "react-router-dom";
import { surgeryPrimaryOderMenuItems } from "utils/data";
import {
  START_CREATE_RX,
  RESET_COLLECTION_STATE,
  START_GET_COLLECTION_LIST,
} from "Actions/CollectionAction";
import { ReactComponent as Phone } from "Assets/Icons/phone.svg";
import { ReactComponent as Email } from "Assets/Icons/email (1).svg";
import { ReactComponent as Fax } from "Assets/Icons/FaxIco.svg";
import { ReactComponent as Other } from "Assets/Icons/Other.svg";
import { getLocalStorage } from "utils/generalUtils";
import RepeatOrderToOrder from "./RepeatOrderToOrder";
import CreateNewRx from "./CreateNewRx";
import { START_GET_HOME_LIST } from "Actions/HomeAction";

const DrugsDialog = React.lazy(() =>
  import("Components/RepeatOrder/DrugsDialog")
);
const ViewOrderDialog = React.lazy(() =>
  import("Components/Common/Dialog/ViewOrderDialog")
);
const RepeatOrderToOrderPadConfirmationDialog = React.lazy(() =>
  import("Components/OrderPad/RepeatOrderToOrderPadConfirmationDialog")
);
const FaxDialog = React.lazy(() =>
  import("Components/Common/Dialog/FaxDialog")
);
const UnTickConfirmationDialog = React.lazy(() =>
  import("Components/OrderPad/UnTickConfirmationDialog")
);

const PatientCreateDialog = React.lazy(() =>
  import("Components/OrderPad/PatientCreateDialog")
);
const UrgentDialog = React.lazy(() => import("./UrgentDialog"));

const OrderPadCreateAndUpdateMain = (props) => {
  const {
    createorderPadAction,
    createOrderPadData,
    createTodayOrderPadAction,
    createTodayOrderPadData,
    getSearchRepeatOrderAction,
    searchRepeatOrder,
    resetOrderPadState,
    getRepeatorderToOrderpadAction,
    repeatOrderToOrderPad,
    createCollectionRxAction,
    createRxDetails,
    resetCollectionRxState,
    resetRepeatOrderState,
    getOrderListAction,
    getCollectionRxAction,
    getHomeListAction,
  } = props;
  const formState = {
    patient_id: "",
    order_id: "",
    comment: "",
    medication: [],

    order_date: new Date(),
    ordering_method: "email",
    surgery_id: "",
    surgery_info: {},
    pharmacy_id: "",
    pharmacy_info: {},
    number_of_medication: "",
    dob: null,
  };
  const navigate = useNavigate();
  const notification = useNotification();
  const [orderPadData, setOrderPadData] = useState(formState);
  const [selectedPatientInfo, setSelectedPatientInfo] = useState({});
  const [showWholeForm, setShowWholeForm] = useState(false);
  const [medications, setMedications] = useState([]);
  const [createDrug, setCreateDrug] = useState(false);
  const [formPayload, setFormPayload] = useState({});
  const [isOpenOrderList, setIsOpenOrderList] = useState(false);
  const [openViewOrder, setOpenViewOrder] = useState(false);
  const [openConfrimationPopup, setOpenConfrimationPopup] = useState(false);
  const [checkAllAction, setCheckAllAction] = useState(false);
  const [openFaxOrder, setOpenFaxOrder] = useState(false);
  const [showOrderList, setShowOrderList] = useState(false);
  const [showCreateNewRx, setShowCreateNewRx] = useState(false);
  const [showNoOfMedication, setShowNoOfMedication] = useState(false);
  const [orderType, setOrderType] = useState("");
  const [openConfrimationTick, setOpenConfrimationTick] = useState(false);
  const [choosePatientShow, setChoosePatientShow] = useState(false);
  const [fax, setFax] = useState(false);
  const [phone, setPhone] = useState(false);
  const [viewOrderData, setViewOrderData] = useState({});
  const [isOpenNewPatientPopup, setIsOpenNewPatientPopup] = useState(false);
  const [urgentOpenDialog, setUrgentOpenDialog] = useState(false);
  // const { selectedHeaderPharmacyId } = useHeaderPharmacySelection();
  const selectedHeaderPharmacyId = getLocalStorage("Pharmacies", true);
  const blankMediation = medications.filter((item) => {
    return item?.name?.trim() === "";
  });
  /* Order Method Array */
  const OrderingMethod = [
    { item: "Phone", type: "phone", icon: <Phone /> },
    { item: "Fax", type: "fax", icon: <Fax /> },
    { item: "Email", type: "email", icon: <Email /> },
    {
      item: "Other",
      type: "other",
      icon: <Other />,
    },
  ];
  const query = new URLSearchParams(window.location.search);

  /* Order By List Array */
  const OrderBYList = [
    { item: "Patient", type: "patient" },
    { item: "Staff", type: "staff" },
  ];
  const [orderBy, setOrderBy] = useState("staff");
  const [showMedication, setShowMedication] = useState(
    query.get("actionType") === "repeatOrderPage" ? false : true
  );

  const allowPatientActionTypes = ["repeatOrderPage", "createNewRx"];
  const currentPageType =
    allowPatientActionTypes.indexOf(query.get("actionType")) === -1
      ? "orderpad"
      : "orderpad collection";

  /**call orderPad list api */
  useEffect(() => {
    if (currentPageType === "orderpad collection") {
      if (query.get("actionType") === "repeatOrderPage") {
        let temObj = {
          order_id: query.get("orderId"),
          patient_id: query.get("patient_id"),
        };
        if (query.get("orderId")) {
          getRepeatorderToOrderpadAction(temObj);
        } else {
          setOrderPadData(formState);
        }
      }
    }
    resetOrderPadState("repeatOrderToOrderPad");
  }, []);

  //return action ticked mediaction array filter
  const medicationActionCheck = medications?.filter((item) => {
    return item.action === true;
  });


  //Order Create  Validation schecma
  let orderPadCreateSchema = {};

  /* CollectionRx Schema */
  let collectionRxSchema = {
    order_date: yup
      .date()
      .nullable()
      .typeError("Date must be follow this format DD-MM-YYYY")
      .required("The next order date field is required."),

    number_of_medication: yup
      .number()
      .nullable(true)
      .min(1, "The number must must be greater than 0."),
  };

  /* Condtion based schema Set */
  let schema = {};
  if (query.get("actionType") !== "createNewRx") {
    schema = orderPadCreateSchema;
  } else if (orderType === "addOrder") {
    schema = collectionRxSchema;
  } else {
    schema = {
      ...orderPadCreateSchema,
      ...collectionRxSchema,
    };
  }
  const orderPadSchema = yup.object().shape({ ...schema });

  /** validate drug */
  const validateDrug = (validationCheckFor = "submit") => {
    if (validationCheckFor === "onChange") {
      const _validateMedication = medications?.map((item) => {
        return (item = {
          ...item,
          errors: {
            name: "",
            quantity: "",
          },
        });
      });
      setMedications(_validateMedication);
      return 0;
    }

    let errorCounter = 0;
    const _validateMedication = medications?.map((item) => {
      if (validationCheckFor === "add") {
        if (item.name.trim() === "" || item.quantity == "") {
          errorCounter++;
        }
      } else {
        item.errors = {
          name: "",
          quantity: "",
        };

        if (item.name.trim() === "" && item.quantity !== "") {
          errorCounter++;
          item.errors.name = "Please enter medication";
        } else if (item.name.trim() !== "") {
          if (item.quantity && item.quantity <= 0) {
            errorCounter++;
            item.errors.quantity = "The quantity  must be greater than 0.";
          }
        }
      }
      return item;
    });
    setMedications(_validateMedication);
    return errorCounter;
  };

  /*   Submit function */
  const handleCreateOrderPad = (formValues) => {
    /** Validate drugs */
    if (showMedication) {
      if (validateDrug() > 0) {
        return false;
      }
    }

    const payload = {
      patient_id:
        query.get("actionType") === "repeatOrderPage"
          ? query.get("patient_id")
          : formValues?.patient_id,
    };
    if (orderType === "addOrder") {
      payload.created_user_type = orderBy;
    }

    if (query.get("actionType") === "repeatOrderPage") {
      payload.order_id = query.get("orderId");
    }

    if (orderType === "addOrder") {
      payload.order_date = moment(new Date(formValues?.order_date)).format(
        "YYYY-MM-DD"
      );
    }

    if (formValues.comment) {
      payload.comment = formValues?.comment;
    }

    if (query.get("actionType") !== "createNewRx") {
      if (formValues.ordering_method) {
        payload.ordering_method = formValues?.ordering_method;
      }
    }

    if (orderType === "createNewOrder") {
      if (formValues.ordering_method) {
        payload.ordering_method = formValues?.ordering_method;
      }
    }

    if (formValues.comment) {
      payload.comment = formValues?.comment;
    }

    const checkMedication = medicationActionCheck.length > 0;

    let actionCheckedCounter = 0;
    let _medications = medications;
    if (checkMedication) {
      _medications = _medications.filter((item) => {
        delete item.errors;
        if (
          item.name.trim() !== ""
          //  &&
          // item.quantity.trim() !== ""
          // && item.action === true
        ) {
          //Return only action checked
          if (item.action === true) {
            //Increment counter
            actionCheckedCounter++;
            return item;
          }
        }
      });
    } else {
      actionCheckedCounter = 1;
    }

    if (actionCheckedCounter > 0) {
      //If specific medication ticked
      if (showMedication) {
        //If medication action ticked
        if (checkMedication) {
          //If drug not present for order and mode is create
          payload.medication = [];
          payload.new_medication = [];
          _medications.map((item) => {
            const { id, name, quantity } = item;
            if (!item.hasOwnProperty("isNew")) {
              payload.medication.push({
                id,
              });
            } else {
              // payload.new_medication = [];
              payload.new_medication.push({
                drug_name: name,
                quantity,
                action: true,
              });
            }
          });
        } else {
          notification.error("Please select medication");
        }
      } else {
        payload.number_of_medication = formValues?.number_of_medication;
      }
      setFormPayload(payload);
      finalSubmitForm(payload);
      // }
    } else {
      notification.error("Please select medication");
    }
  };

  const { guardedSubmit: xssGuardedOrderPad } = useXssGuard(handleCreateOrderPad);


  /* Final Submit Function */
  const finalSubmitForm = (payload) => {
    const _payload = {
      ...formPayload,
      ...payload,
    };
    if (
      query.get("actionType") === "repeatOrderPage" &&
      Object.keys(repeatOrderToOrderPad)?.length > 0
    ) {
      /* Create Repeat Order To OrderPad API Call */
      createorderPadAction(_payload);
    } else if (orderType === "addOrder") {
      /* Create Collection API Call */
      createCollectionRxAction(_payload);
    } else {
      /* Create OrderPad API Call */
      createTodayOrderPadAction(_payload);
    }
  };

  /* Formik */
  const {
    handleSubmit,
    handleChange,
    values,
    errors,
    touched,
    handleBlur,
    resetForm,
    setErrors,
    setFieldValue,

  } = useFormik({
    initialValues: { ...orderPadData },
    validationSchema: orderPadSchema,
    enableReinitialize: true,
    onSubmit: xssGuardedOrderPad,
  });

  /* Set handle change for show patient details */
  const handlePatientDetailsChange = (value) => {
    //If value selected
    if (value) {
      getSearchRepeatOrderAction(value?.id);
      setShowWholeForm(true);
    } else {
      //If clear
      setShowWholeForm(false);
      resetForm();
    }
  };

  //Add new drug
  const handleOnAddDrug = (drugObject) => {
    setMedications([...medications, drugObject]);
  };

  //Submit patient info call back function
  const callBackOnSubmitPatientInfo = () => {
    //List api call
    getSearchRepeatOrderAction(
      selectedPatientInfo?.patient_id || selectedPatientInfo?.id
    );
  };

  //Cancel Call back function
  const callBackOnCancelPatientInfo = () => { };

  /**setData of order pad  */
  useEffect(() => {
    if (
      query.get("actionType") === "repeatOrderPage" &&
      !repeatOrderToOrderPad?.loading &&
      Object.keys(repeatOrderToOrderPad?.data)?.length > 0
    ) {
      const {
        patient_medications,
        dob,
        name,
        last_name,
        patient_id,
        surgery,
        pharmacy,
        medication_date,
        number_of_medication,
        medication_type,
      } = repeatOrderToOrderPad?.data;
      setShowWholeForm(true);
      setFieldValue("name", name);
      setFieldValue("dob", dob);
      setFieldValue("medication_date", medication_date);
      // moment(moment()).add(3, "days")
      setOrderPadData({
        ordering_method: surgery?.ordering_method,
        surgery_id: surgery?.id || "",
        surgery_info: surgery,
        pharmacy_id: pharmacy?.id || "",
        pharmacy_info: pharmacy,
        number_of_medication: number_of_medication || "",
        dob: dob || null,
      });

      setSelectedPatientInfo({
        patient_id,
        name,
        dob,
        last_name,
      });
      let Meditype = getLocalStorage("medi_type");
      if (medication_type === null) {
        setShowMedication(true);
      } else {
        if (Meditype === "number") {
          setShowNoOfMedication(true);
        } else if (Meditype === "specific") {
          setShowMedication(true);
        }
      }

      const medications = patient_medications.map((item) => {
        item.action = item?.is_action;
        return item;
      });
      /**filter duplicate drugs */
      const uniqueMeditation = medications.reduce((accumulator, current) => {
        if (!accumulator.find((item) => item.name === current.name)) {
          accumulator.push(current);
        }
        return accumulator;
      }, []);
      setMedications(uniqueMeditation);
    }
  }, [repeatOrderToOrderPad?.data]);

  /** set search order data */
  useEffect(() => {
    if (
      currentPageType === "orderpad" ||
      (currentPageType === "orderpad collection" &&
        !searchRepeatOrder?.loading &&
        Object.keys(searchRepeatOrder?.data || {})?.length > 0)
    ) {
      setSelectedPatientInfo({
        ...selectedPatientInfo,
        last_name: searchRepeatOrder?.data?.data?.last_name,
        name: searchRepeatOrder?.data?.data?.name,
        dob: searchRepeatOrder?.data?.data?.dob
          ? searchRepeatOrder?.data?.data?.dob
          : "",
      });
      setFieldValue("name", searchRepeatOrder?.data?.data?.name);
      setFieldValue(
        "surgery_info",
        searchRepeatOrder?.data?.data?.surgery_name
      );
      setFieldValue(
        "surgery_id",
        searchRepeatOrder?.data?.data?.surgery_name.id
      );
      setFieldValue(
        "pharmacy_info",
        searchRepeatOrder?.data?.data?.pharmacy_name
      );
      setFieldValue(
        "pharmacy_id",
        searchRepeatOrder?.data?.data?.pharmacy_name.id
      );
      setFieldValue(
        "dob",
        searchRepeatOrder?.data?.data?.dob
          ? searchRepeatOrder?.data?.data?.dob
          : ""
      );
      setFieldValue(
        "ordering_method",
        searchRepeatOrder?.data?.data?.surgery_name?.ordering_method
      );
      const actionedCheckedMedications =
        medicationActionCheck?.map((item) => item.id) || [];
      const manipulateDrugs = searchRepeatOrder?.data?.data?.drugs?.map(
        (item) => {
          item.action = actionedCheckedMedications.includes(item.id);
          return item;
        }
      );
      /**filter duplicate drugs */
      const uniqueMeditation = manipulateDrugs?.reduce(
        (accumulator, current) => {
          if (!accumulator.find((item) => item.name === current.name)) {
            accumulator.push(current);
          }
          return accumulator;
        },
        []
      );
      setMedications(uniqueMeditation);
    }
  }, [searchRepeatOrder]);

  //Create & edit order loading  true useEffect
  useEffect(() => {
    if (
      (!createOrderPadData?.loading &&
        Object.keys(createOrderPadData?.data || {})?.length > 0) ||
      (!createTodayOrderPadData?.loading &&
        Object.keys(createTodayOrderPadData?.data || {})?.length > 0)
    ) {
      resetForm();
      setShowWholeForm(false);
      setSelectedPatientInfo({});
      //Fire action to reset redux
      resetOrderPadState("createOrderPadData");
      resetRepeatOrderState("searchRepeatOrder");
      resetOrderPadState("repeatOrderToOrderPad");
      resetOrderPadState("createTodayOrderPadData");
      resetCollectionRxState("createRxDetails");
      if (
        selectedHeaderPharmacyId !== "" &&
        selectedHeaderPharmacyId !== "all"
      ) {
        let payloadHome = { pharmacy_id: [selectedHeaderPharmacyId] };
        getHomeListAction(payloadHome);
      } else {
        getHomeListAction();
      }
    }
  }, [createOrderPadData, createTodayOrderPadData]);

  //Collection Rx Loading useeffect
  useEffect(() => {
    if (
      !createRxDetails?.loading &&
      Object.keys(createRxDetails?.data || {})?.length > 0
    ) {
      resetForm();
      setShowWholeForm(false);
      setSelectedPatientInfo({});
      //Fire action to reset redux
      resetCollectionRxState("createRxDetails");
      resetRepeatOrderState("searchRepeatOrder");
      if (
        selectedHeaderPharmacyId !== "" &&
        selectedHeaderPharmacyId !== "all"
      ) {
        let payloadHome = { pharmacy_id: [selectedHeaderPharmacyId] };
        getHomeListAction(payloadHome);
      } else {
        getHomeListAction();
      }
    }
  }, [createRxDetails]);

  //Collection Rx success useeffect
  useEffect(() => {
    if (createRxDetails?.data?.success === true) {
      navigate("/order");
    }
  }, [createRxDetails?.data?.success]);

  //Create & edit order Success redirect to order page
  useEffect(() => {
    let payload = {
      offset: 0,
      is_chase_up: getLocalStorage("chaseUp") == "true" ? true : false,
      type: "un_collected",
    };
    let payLoad = {
      offset: 0,
      type: "today",
    };
    if (createOrderPadData?.data?.success === true) {
      navigate("/order");
      setSelectedPatientInfo({});
      if (
        selectedHeaderPharmacyId !== "" &&
        selectedHeaderPharmacyId !== "all"
      ) {
        payLoad = {
          offset: 0,
          type: "all",
          pharmacy_id: [selectedHeaderPharmacyId],
        };
        let payload = {
          offset: 0,
          is_chase_up: getLocalStorage("chaseUp") == "true" ? true : false,
          type: "un_collected",
          pharmacy_id: [selectedHeaderPharmacyId],
        };
        getCollectionRxAction(payload);
      } else {
        getCollectionRxAction(payload);
      }
    } else if (createTodayOrderPadData?.data?.success === true) {
      navigate("/order");
      setSelectedPatientInfo({});
      if (
        selectedHeaderPharmacyId !== "" &&
        selectedHeaderPharmacyId !== "all"
      ) {
        payLoad = {
          offset: 0,
          type: "all",
          pharmacy_id: [selectedHeaderPharmacyId],
        };
        let payload = {
          offset: 0,
          is_chase_up: getLocalStorage("chaseUp") == "true" ? true : false,
          type: "un_collected",
          pharmacy_id: [selectedHeaderPharmacyId],
        };
        getCollectionRxAction(payload);
      } else {
        getCollectionRxAction(payload);
      }
    }
  }, [
    createOrderPadData?.data?.success,
    createTodayOrderPadData?.data?.success,
  ]);

  //Sever side error useeffect
  useEffect(() => {
    const errors =
      query.get("actionType") === "repeatOrderPage"
        ? createOrderPadData?.error?.errors
        : createTodayOrderPadData?.error?.errors;
    if (errors && Object?.keys(errors)?.length > 0) {
      let obj = {};
      Object.entries(errors)?.map(([item, value]) => {
        obj[item] = value[0];
        return item;
      });
      setErrors(obj);
    }
  }, [createOrderPadData?.error, createTodayOrderPadData.error]);

  useEffect(() => {
    if (query.get("actionType") !== "repeatOrderPage") {
      setSelectedPatientInfo({});
    }
  }, []);

  /* Handle Change Action */
  const handleChangeAction = (e, index) => {
    const allDrug = medications;
    allDrug[index] = {
      ...allDrug[index],
      action: !allDrug[index]?.action,
    };
    setMedications([...allDrug]);
  };

  /* CheckAction tick medication */
  useEffect(() => {
    const checkeAction = medications?.filter((item) => {
      return item.action;
    });
    setCheckAllAction(checkeAction?.length === medications?.length);
  }, [medications]);

  /* Select Order method */
  const selectedOrderMethodOption = () => {
    if (values?.ordering_method !== "") {
      const otpion = surgeryPrimaryOderMenuItems.filter((item) => {
        return item.value === values?.ordering_method;
      });
      if (otpion.length > 0) {
        return otpion[0].label;
      }
    }
    return "";
  };

  /* Handle Dialog Funcation */
  const handleDialog = (medications = [], numberOfMedication = 0, item) => {
    let tempData = {};
    if (query.get("actionType") === "repeatOrderPage") {
      let tempCollected = 0;
      let tempRemoved = 0;
      repeatOrderToOrderPad?.data?.patient_number_of_medication?.map(
        (item, index) => {
          if (item.status === "Collected") {
            tempCollected += parseInt(item.pnom_medication_no);
          }
          if (item.status === "Removed") {
            tempRemoved += parseInt(item.pnom_medication_no);
          }
        }
      );
      // repeatOrderToOrderPad
      let tempNumberOfMedication =
        repeatOrderToOrderPad?.data?.number_of_medication || numberOfMedication;
      tempData = {
        medication:
          medications.length > 0
            ? medications
            : repeatOrderToOrderPad?.data?.patient_medications,
        surgeryName: repeatOrderToOrderPad?.data?.surgery?.name,
        surgeryEmail: repeatOrderToOrderPad?.data?.surgery?.email,
        dob: repeatOrderToOrderPad?.data?.dob
          ? repeatOrderToOrderPad?.data?.dob
          : "",
        name: repeatOrderToOrderPad?.data?.name,
        last_name: repeatOrderToOrderPad?.data?.last_name,
        medication_type: showNoOfMedication == true ? "number" : "specific",
        number_of_medication: tempNumberOfMedication,
        medicationCollected: tempCollected,
        medicationRemoved: tempRemoved,
        medicationUncollected:
          tempNumberOfMedication - tempCollected - tempRemoved,
        phone: repeatOrderToOrderPad?.data?.surgery?.phone,
        fax: repeatOrderToOrderPad?.data?.surgery?.fax,
      };
      setViewOrderData(tempData);
    } else {
      let tempCollected = 0;
      let tempRemoved = 0;
      searchRepeatOrder?.data?.data?.data?.patient_number_of_medication?.map(
        (item, index) => {
          if (item.status === "Collected") {
            tempCollected += parseInt(item.pnom_medication_no);
          }
          if (item.status === "Removed") {
            tempRemoved += parseInt(item.pnom_medication_no);
          }
        }
      );
      let tempNumberOfMadication =
        searchRepeatOrder?.data?.data?.number_of_medication ||
        numberOfMedication;
      tempData = {
        medication:
          medications.length > 0
            ? medications
            : searchRepeatOrder?.data?.data?.drugs,
        surgeryName: searchRepeatOrder?.data?.data?.surgery_name?.name,
        surgeryEmail: searchRepeatOrder?.data?.data?.surgery_name?.email,
        dob: searchRepeatOrder?.data?.data?.dob
          ? searchRepeatOrder?.data?.data?.dob
          : "",
        name: searchRepeatOrder?.data?.data?.name,
        last_name: searchRepeatOrder?.data?.data?.last_name,
        medication_type: showNoOfMedication == true ? "number" : "specific",
        number_of_medication: tempNumberOfMadication,
        medicationCollected: tempCollected,
        medicationRemoved: tempRemoved,
        medicationUncollected:
          tempNumberOfMadication - tempCollected - tempRemoved,
        phone: searchRepeatOrder?.data?.data?.surgery_name?.phone,
        fax: searchRepeatOrder?.data?.data?.surgery_name?.fax,
      };
      setViewOrderData(tempData);
    }
    if (item === "email" || item === null) {
      setOpenViewOrder(true);
    } else {
      if (item === "fax") {
        setFax(true);
      }
      if (item === "phone") {
        setPhone(true);
      }
      setOpenFaxOrder(true);
    }
  };

  /* On Success Submit Patient */
  const onSuccessOfSubmitPatientForm = (responseData) => {
    const data = responseData;
    const { id, name, last_name, dob, status } = data;
    const objPatientInfo = {
      id,
      name,
      last_name,
      dob,
      status,
    };
    setFieldValue("name", name);
    setSelectedPatientInfo(objPatientInfo);
    setFieldValue("patient_id", id);
    setShowWholeForm(true);
    setFieldValue("surgery_info", {
      id: responseData?.surgery?.id,
      email: responseData?.surgery?.email,
      name: responseData?.surgery?.name,
    });
    setFieldValue("surgery_id", responseData?.surgery?.id);
    setFieldValue("surgery_info", {
      id: responseData?.surgery?.id,
      email: responseData?.surgery?.email,
      name: responseData?.surgery?.name,
    });
    setFieldValue("surgery_id", responseData?.surgery?.id);
    setFieldValue("pharmacy_info", {
      id: responseData?.surgery?.id,
      name: responseData?.pharmacy?.name,
    });
    setFieldValue("pharmacy_id", responseData?.pharmacy?.id);

    const drugInfo = responseData?.drugs?.map((item) => {
      return item;
    });

    const uniqueMeditation = drugInfo?.reduce((accumulator, current) => {
      if (!accumulator.find((item) => item.name === current.name)) {
        accumulator.push(current);
      }
      return accumulator;
    }, []);
    setMedications(uniqueMeditation);
  };

  return (
    <>
      {query.get("actionType") === "repeatOrderPage" && (
        <RepeatOrderToOrder
          OrderingMethod={OrderingMethod}
          handleSubmit={handleSubmit}
          selectedPatientInfo={selectedPatientInfo}
          query={query}
          setSelectedPatientInfo={setSelectedPatientInfo}
          setFieldValue={setFieldValue}
          handlePatientDetailsChange={handlePatientDetailsChange}
          currentPageType={currentPageType}
          touched={touched}
          errors={errors}
          createDrug={createDrug}
          setCreateDrug={setCreateDrug}
          handleOnAddDrug={handleOnAddDrug}
          medications={medications}
          callBackOnSubmitPatientInfo={callBackOnSubmitPatientInfo}
          values={values}
          handleChange={handleChange}
          OrderBYList={OrderBYList}
          orderBy={orderBy}
          setOrderBy={setOrderBy}
          navigate={navigate}
          orderType={orderType}
          showMedication={showMedication}
          setOrderType={setOrderType}
          setShowMedication={setShowMedication}
          setShowNoOfMedication={setShowNoOfMedication}
          showNoOfMedication={showNoOfMedication}
          checkAllAction={checkAllAction}
          setCheckAllAction={setCheckAllAction}
          setMedications={setMedications}
          handleChangeAction={handleChangeAction}
          medicationActionCheck={medicationActionCheck}
          handleBlur={handleBlur}
          isOpenOrderList={isOpenOrderList}
          setIsOpenOrderList={setIsOpenOrderList}
          selectedOrderMethodOption={selectedOrderMethodOption}
          showWholeForm={showWholeForm}
          handleDialog={handleDialog}
          createOrderPadData={createOrderPadData}
          setIsOpenNewPatientPopup={setIsOpenNewPatientPopup}
          setOpenConfrimationPopup={setOpenConfrimationPopup}
          repeatOrderToOrderPad={repeatOrderToOrderPad}
          setUrgentDialog={setUrgentOpenDialog}
          urgentDialog={urgentOpenDialog}
          validateDrug={validateDrug}
          blankMediation={blankMediation}
        />
      )}
      {(query.get("actionType") === "createNewRx" ||
        currentPageType === "orderpad") && (
          <CreateNewRx
            OrderingMethod={OrderingMethod}
            handleSubmit={handleSubmit}
            selectedPatientInfo={selectedPatientInfo}
            query={query}
            setSelectedPatientInfo={setSelectedPatientInfo}
            setFieldValue={setFieldValue}
            handlePatientDetailsChange={handlePatientDetailsChange}
            currentPageType={currentPageType}
            touched={touched}
            errors={errors}
            createDrug={createDrug}
            setCreateDrug={setCreateDrug}
            handleOnAddDrug={handleOnAddDrug}
            medications={medications}
            callBackOnSubmitPatientInfo={callBackOnSubmitPatientInfo}
            values={values}
            handleChange={handleChange}
            OrderBYList={OrderBYList}
            orderBy={orderBy}
            setOrderBy={setOrderBy}
            navigate={navigate}
            orderType={orderType}
            showMedication={showMedication}
            setOrderType={setOrderType}
            setShowMedication={setShowMedication}
            setShowNoOfMedication={setShowNoOfMedication}
            showNoOfMedication={showNoOfMedication}
            checkAllAction={checkAllAction}
            setCheckAllAction={setCheckAllAction}
            setMedications={setMedications}
            handleChangeAction={handleChangeAction}
            medicationActionCheck={medicationActionCheck}
            handleBlur={handleBlur}
            isOpenOrderList={isOpenOrderList}
            setIsOpenOrderList={setIsOpenOrderList}
            selectedOrderMethodOption={selectedOrderMethodOption}
            showWholeForm={showWholeForm}
            handleDialog={handleDialog}
            createOrderPadData={createOrderPadData}
            showOrderList={showOrderList}
            setShowOrderList={setShowOrderList}
            setShowCreateNewRx={setShowCreateNewRx}
            showCreateNewRx={showCreateNewRx}
            choosePatientShow={choosePatientShow}
            setIsOpenNewPatientPopup={setIsOpenNewPatientPopup}
            setOrderPadData={setOrderPadData}
            formState={formState}
            setShowWholeForm={setShowWholeForm}
          />
        )}
      <DrugsDialog
        open={createDrug}
        setOpen={setCreateDrug}
        onAddDrug={handleOnAddDrug}
        medications={medications}
        patient_id={selectedPatientInfo?.patient_id || selectedPatientInfo?.id}
        actionType={query.get("actionType")}
        searchRepeatOrder={searchRepeatOrder}
        getSearchRepeatOrderAction={getSearchRepeatOrderAction}
        callBackOnSubmitPatientInfo={callBackOnSubmitPatientInfo}
        callBackOnCancelPatientInfo={callBackOnCancelPatientInfo}
      />
      <ViewOrderDialog
        displayType={showNoOfMedication}
        open={openViewOrder}
        setOpen={setOpenViewOrder}
        viewOrderData={viewOrderData}
        actionType={query.get("actionType")}
      />
      <RepeatOrderToOrderPadConfirmationDialog
        open={openConfrimationPopup}
        setOpen={setOpenConfrimationPopup}
        repeatOrderToOrderPad={repeatOrderToOrderPad}
        onSubmit={finalSubmitForm}
      />
      <FaxDialog
        open={openFaxOrder}
        setOpen={setOpenFaxOrder}
        viewOrderData={viewOrderData}
        body={
          query.get("actionType") === "repeatOrderPage"
            ? repeatOrderToOrderPad
            : searchRepeatOrder?.data
        }
        actionType={query.get("actionType")}
        phone={phone}
        setPhone={setPhone}
        fax={fax}
        setFax={setFax}
      />
      <UnTickConfirmationDialog
        open={openConfrimationTick}
        setOpen={setOpenConfrimationTick}
        title="Are you sure?"
        body="You wan't be able to change!"
        setShowOrderList={setShowOrderList}
        setShowCreateNewRx={setShowCreateNewRx}
        setSelectedPatientInfo={setSelectedPatientInfo}
        showCreateNewRx={showCreateNewRx}
        setChoosePatientShow={setChoosePatientShow}
        showOrderList={showOrderList}
        setShowWholeForm={setShowWholeForm}
        setOrderPadData={setOrderPadData}
        formState={formState}
        orderType={orderType}
        actionBtnTitle="Yes"
      />
      <PatientCreateDialog
        open={isOpenNewPatientPopup}
        setOpen={setIsOpenNewPatientPopup}
        callBackOnSubmit={onSuccessOfSubmitPatientForm}
      />
      <UrgentDialog open={urgentOpenDialog} setOpen={setUrgentOpenDialog} />
    </>
  );
};

const mapStateToProps = (state) => ({
  createOrderPadData: state.orderPad.createOrderPadData,
  createRxDetails: state.collection.createRxDetails,
  searchRepeatOrder: state.order.searchRepeatOrder,
  repeatOrderToOrderPad: state.orderPad.repeatOrderToOrderPad,
  createTodayOrderPadData: state.orderPad.createTodayOrderPadData,
  collectionViewRxDetails: state.collection.collectionViewRxDetails,
  singleRepeatOrder: state.order.singleRepeatOrder,
});

const mapDispatchToProps = (dispatch) => ({
  getCollectionRxAction: (payload) =>
    dispatch({ type: START_GET_COLLECTION_LIST, payload }),
  createorderPadAction: (payload) =>
    dispatch({ type: START_CREATE_ORDER_PAD, payload }),
  createCollectionRxAction: (payload) =>
    dispatch({ type: START_CREATE_RX, payload }),
  createTodayOrderPadAction: (payload) =>
    dispatch({ type: START_CREATE_TODAY_ORDER_PAD, payload }),
  getSearchRepeatOrderAction: (id) =>
    dispatch({ type: START_GET_SEARCH_REPEAT_ORDER, id }),
  resetOrderPadState: (key, payload) =>
    dispatch({ type: RESET_ORDER_PAD_STATE, key, payload }),
  resetRepeatOrderState: (key, payload) =>
    dispatch({ type: RESET_REPEAT_ORDER_STATE, key, payload }),
  resetCollectionRxState: (key, payload) =>
    dispatch({ type: RESET_COLLECTION_STATE, key, payload }),
  getOrderListAction: (payload) =>
    dispatch({ type: START_GET_REPEAT_ORDER_LIST, payload }),
  getRepeatorderToOrderpadAction: (payload) =>
    dispatch({ type: START_REPEATORDER_TO_ORDERPAD, payload }),
  getHomeListAction: (payload) =>
    dispatch({ type: START_GET_HOME_LIST, payload }),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(OrderPadCreateAndUpdateMain);
